module.exports = __webpack_public_path__ + "img/23.b194d1bc.jpg";